import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useCompanyPageStore } from "../../../store/companyPageStore";
import { ITSpendBreakdown } from "./components/Spend/ITSpendBreakdown";
import { AISpendBreakdown } from "./components/Spend/AISpendBreakdown";
import { CompanySpendByCountry } from "./components/Spend/CompanySpendByCountry";
import { ProportionalITSpend } from "./components/Spend/ProportionalITSpend";

export const SpendView = () => {
  const company = useCompanyPageStore((state) => state.company);

  if (!company) return null;

  return (
    <Box>
      <Grid container spacing={3}>
        {/* Top Row - IT Spend Breakdown and Company Count */}
        <Grid size={{ xs: 12, md: 6 }}>
          <ITSpendBreakdown />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <CompanySpendByCountry />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <AISpendBreakdown />
        </Grid>

        {/* Bottom Row - Proportional IT Spend */}
        <Grid size={12}>
          <ProportionalITSpend />
        </Grid>
      </Grid>
    </Box>
  );
};
